import { render, staticRenderFns } from "./DialogFormModelAdd.vue?vue&type=template&id=162d6c50"
import script from "./DialogFormModelAdd.vue?vue&type=script&lang=js"
export * from "./DialogFormModelAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports